import api from './../api'
import buildQuery from './../../helpers/query/buildQuery'

export const getListLabels = (params) => {
    const query = buildQuery(params)

    return api.makeAuthRequest({
        url: `labels?${query}`,
        method: 'GET',
    })
}